export default __webpack_public_path__ + "static/media/fingermouth.705ea2cb.png";